"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describeSubnet = describeSubnet;
exports.describeSubnets = describeSubnets;
exports.describeVpc = describeVpc;
exports.describeVpcs = describeVpcs;
exports.modifyVpc = modifyVpc;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var _util = require("@jdcloud/jelement-biz/dist/utils/util");
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var axios = new _axios.default({
  extra: {
    componentName: 'cocvpc'
  }
});

// vpc列表获取
function describeVpcs(_ref) {
  var regionId = _ref.regionId,
    cancelToken = _ref.cancelToken,
    _ref$pageNumber = _ref.pageNumber,
    pageNumber = _ref$pageNumber === void 0 ? 1 : _ref$pageNumber,
    filters = _ref.filters;
  return axios({
    url: '/openApi/cocvpc/describeVpcs',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        pageNumber: pageNumber,
        pageSize: _util.DEFAULT_INFINITE_SCROLL_SIZE,
        filters: filters
      }
    },
    cancelToken: cancelToken
  });
}

// vpc详情获取
//https://coding.jd.com/jcloud-api-gateway/jcloud-open-api-doc/blob/internal/cocvpc/Virtual-Private-Cloud/describeVpc.md
function describeVpc(_ref2) {
  var regionId = _ref2.regionId,
    vpcId = _ref2.vpcId,
    cancelToken = _ref2.cancelToken;
  return axios({
    url: '/openApi/cocvpc/describeVpc',
    method: 'GET',
    params: {
      regionId: regionId,
      params: {
        vpcId: vpcId
      }
    },
    cancelToken: cancelToken
  });
}

//https://coding.jd.com/jcloud-api-gateway/jcloud-open-api-doc/blob/internal/cocvpc/Virtual-Private-Cloud/modifyVpc.md
function modifyVpc(_ref3) {
  var regionId = _ref3.regionId,
    params = _ref3.params,
    cancelToken = _ref3.cancelToken;
  return axios({
    url: '/openApi/cocvpc/modifyVpc',
    method: 'GET',
    params: {
      regionId: regionId,
      params: _objectSpread({}, params)
    },
    cancelToken: cancelToken
  });
}

// 子网列表获取
function describeSubnets(_ref4) {
  var regionId = _ref4.regionId,
    filters = _ref4.filters,
    cancelToken = _ref4.cancelToken,
    _ref4$pageNumber = _ref4.pageNumber,
    pageNumber = _ref4$pageNumber === void 0 ? 1 : _ref4$pageNumber;
  return axios({
    url: '/openApi/cocvpc/describeSubnets',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        pageNumber: pageNumber,
        pageSize: _util.DEFAULT_INFINITE_SCROLL_SIZE,
        filters: filters
      }
    },
    cancelToken: cancelToken
  });
}

// 子网获取
function describeSubnet(_ref5) {
  var regionId = _ref5.regionId,
    subnetId = _ref5.subnetId,
    cancelToken = _ref5.cancelToken;
  return axios({
    url: '/openApi/cocvpc/describeSubnet',
    method: 'GET',
    params: {
      regionId: regionId,
      params: {
        subnetId: subnetId
      }
    },
    cancelToken: cancelToken
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/cocvpc.js
// module id = sgSb
// module chunks = 19